import { lazy } from 'react';

export const LazyActivation = lazy(() => {
  return import('./index');
});
